import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }, structure) => {
  commit(types.COMMANDE_TOGGLE_LOADING);

  axios
    .get(URL_BACKEND + "api-commande/structure/" + structure + "/")
    .then((response) => {
      commit(types.COMMANDE_TOGGLE_LOADING);
      commit(types.COMMANDE_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.COMMANDE_SET_ITEMS, []);
      commit(types.COMMANDE_TOGGLE_LOADING);
      commit(types.COMMANDE_SET_ERROR, e.message);
    });
};
